import { useSimpleModalState } from 'approot/shared/modal/modal.hooks';
import SubActivityView from '../../sub-activity/sub-activity-view';
import { ComponentOverlayWrapper } from '../../shared/component-overlay/component-overlay.style';
import { getComponentSelectorId } from '../../shared/logic/get-component-selector-id';
import { getSubActivityInstructionAsText } from '../../sub-activity/sub-activity.utils';
import ComponentOverlaySample from '../../shared/component-overlay/component-overlay-sample';
import { ViewProps } from '../table.constants';
import TableViewSampleAnswerModal from './table-view-sample-answer-modal';
import TableReadonlyAnswers from '../table-readonly-answers';
import { SampleProps } from '../../sample/activity-sample.constants';

const TableSampleView = (props: ViewProps & SampleProps) => {
  const {
    id,
    subActivityProperties,
    properties: {
      table: { isReadOnly },
    },
  } = props;

  const { isVisible, openModal, closeModal } = useSimpleModalState();

  return (
    <SubActivityView subActivityDetails={subActivityProperties}>
      {isVisible && (
        <TableViewSampleAnswerModal {...props} onClose={closeModal} />
      )}

      <ComponentOverlayWrapper id={getComponentSelectorId(id)}>
        <TableReadonlyAnswers {...props} answers={null} />
        {!isReadOnly ? (
          <ComponentOverlaySample
            ariaLabel={`Fill in the table to answer: ${getSubActivityInstructionAsText(
              subActivityProperties?.instructions
            )}`}
            onClick={openModal}
          />
        ) : null}
      </ComponentOverlayWrapper>
    </SubActivityView>
  );
};

export default TableSampleView;
